export interface DynamicTrustMarkerTag {
  tagName: string;
}

export interface AwardTrustMarker {
  tagName: string;
  awardYear: string;
  logoUrl: string;
}

export interface TrustMarkers {
  dynamicTrustmarkerTags: DynamicTrustMarkerTag[];
  awardTrustmarkers: AwardTrustMarker[];
}

export interface ModelTrustMarkers {
  id: number;
  name: string;
  slug: string;
  trustMarkers: TrustMarkers;
}

export enum TrustMarkerType {
  NEWLY_LAUNCHED = "Newly Launched",
  BEST_SELLER = "Best Seller",
  MOST_VIEWED = "Most Viewed",
  MOST_SEARCHED = "Most Searched",
}

export interface TrustMarkerPriority {
  type: string;
  priority: number;
}

